module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAeklEQVR42mNgGIrgf6bkf3RMSM3wcAA2i3FZNLwcQIzF6JbRzgGzU3BjIkKGMp/js5yAI2jrcyIcQnufE3AE/XyOwxH09Tm5UUF1y7E4hn4+JyVNDD4HUMsx5BZMtHDAwGTDUQeMOmDUAaMOGHUA1ZpkVMBDywEjCgAA2Nxh7qU62zQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/captadas_uni_con.png
// module id = sPns
// module chunks = 0